import styled from 'styled-components'
import { Card } from 'antd'

const StyledCard = styled(Card)`
  > .ant-card-head {
    > .ant-tabs  {
      background: transparent;
    }
  }
`

export {
  StyledCard
}
